import { transitionElement } from "./helpers/transition_element";

const SELECTOR_CONTAINER = ".vjs-autoplay__container";
const SELECTOR_CONTENT = ".vjs-autoplay__content";
const SELECTOR_RESTART = ".js-autoplay-restart";

const CLASS_HIDDEN = "vjs-autoplay--hidden";
const CLASS_CLOSE_OVERLAY = "js-close-cta-overlay";
const DEFAULT_BUY_CTA_CLASS = "js-buy-course";
const DEFAULT_GIFT_CTA_CLASS = "js-gift-course";

export default function setupCtaOverlay(player) {
  // Disable looping to allow the 'ended' event to fire
  player.loop(false);

  appendCtaDialog(player);

  $(document).on("turbolinks:before-cache", () => {
    player.off("ended", ctaOverlayInit);
  });

  player.on("ended", ctaOverlayInit);

  function ctaOverlayInit() {
    animateDialogIn(player);

    setupEvents(player);
    $(`.${CLASS_CLOSE_OVERLAY}`).on("click", () => player.exitFullscreen());
  }
}

// ***** TRANSITIONS ***** \\
async function animateDialogIn(player) {
  player.addClass("vjs-big-play-button--hidden");

  await transitionElement(
    player.el().querySelector(SELECTOR_CONTAINER),
    "remove",
    CLASS_HIDDEN
  );
  await transitionElement(
    player.el().querySelector(SELECTOR_CONTENT),
    "remove",
    CLASS_HIDDEN
  );
}

async function animateDialogOut(player) {
  await transitionElement(
    player.el().querySelector(SELECTOR_CONTENT),
    "add",
    CLASS_HIDDEN
  );
  await transitionElement(
    player.el().querySelector(SELECTOR_CONTAINER),
    "add",
    CLASS_HIDDEN
  );
}

// ***** EVENTS ***** \\
// Setup restart event
function setupEvents(player) {
  $(player.el())
    .find(SELECTOR_RESTART)
    .on("click", () => {
      animateDialogOut(player);

      player.play();
      setTimeout(() => {
        player.currentTime(0);
      }, 10);
    });
}

// ***** MARKUP ***** \\
function appendCtaDialog(player) {
  // Create markup
  const $wrapper = $(
    '<div class="vjs-autoplay__container vjs-autoplay--hidden vjs-cta-overlay"></div>'
  ).html(getMarkup(player));

  // Append to DOM
  $(player.el()).append($wrapper);
}

function getMarkup(player) {
  const buyPath = player.el().dataset.buyPath;
  const buyText = player.el().dataset.buyText;
  const buyCtaClass = player.el().dataset.buyCtaClass || DEFAULT_BUY_CTA_CLASS;
  const giftPath = player.el().dataset.giftPath;
  const giftText = player.el().dataset.giftText;
  const giftCtaClass =
    player.el().dataset.giftCtaClass || DEFAULT_GIFT_CTA_CLASS;

  // Markup has been separated as preorder videos shouldn't
  // have a gift cta
  const markupStart = `
    <button class="vjs-fullscreen-control vjs-control vjs-cta-overlay__close ${CLASS_CLOSE_OVERLAY}" title="Exit Fullscreen" type="button">
      <span aria-hidden="true" class="vjs-icon-placeholder"></span>
    </button>
    <div class="vjs-autoplay__content vjs-autoplay--hidden">
      <div class="h3 text-center text-tertiary mb-3 mb-lg-5 d-none d-sm-block">Ready to get started?</div>
      <div class="vjs-autoplay__btn-box justify-content-center vjs-cta-overlay__btns">`;

  const buyCta = `
    <a class="btn btn-cta btn-primary ${buyCtaClass} vjs-cta-overlay__btns--btn" href="${buyPath}">
      <span>${buyText}</span>
    </a>`;

  const giftCtaMarkup = `
    <a class="btn btn-cta btn-ghost btn-ghost-dark bg-transparent ${giftCtaClass} vjs-cta-overlay__btns--btn" data-remote="true" href="${giftPath}">
      <span>${giftText}</span>
    </a>
  `;

  const giftCta = giftPath ? giftCtaMarkup : "";

  const markupEnd = `
      </div>
      <div class="mt-4 mt-md-5">
        <button class="vjs-autoplay__btn js-autoplay-restart mx-auto">
          Restart
        </button>
      </div>
    </div>
  `;

  if (player.el().dataset.coursePreorder) {
    return markupStart + buyCta + markupEnd;
  } else {
    return markupStart + buyCta + giftCta + markupEnd;
  }
}
